import { render } from "./static.vue?vue&type=template&id=fe9b9fa6&scoped=true"
import script from "./static.vue?vue&type=script&lang=js"
export * from "./static.vue?vue&type=script&lang=js"

import "./static.vue?vue&type=style&index=0&id=fe9b9fa6&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/qixiao_410_6413_沙箱云前端生产环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe9b9fa6"]])

export default __exports__